module.exports = __webpack_public_path__ + "static/img/10.732fa2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/sp/10.png
// module id = 4kVi
// module chunks = 0